module.exports = __webpack_public_path__ + "img/dialogue-icon-active.3e570739.svg";